(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for one appointment-type 
    module.directive('agendaAppointmentType', [function () {
        var directive = {
            restrict: 'A',
            templateUrl: '/app/agenda/templates/agenda-appointment-type.template.html',
            scope: {
                appointmentType: '='
            }
        };
        return directive;       
    }]);

})();